import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './autoPay.json';

const autoPayInit = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoPayController/autoPayInit'].success.default)));
};
const getPayPageInit = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoPayController/getPayPageInit'].success.default)));
};
const validateCreditCard = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['autoPayController/validateCreditCard'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('autoPayController/autoPayInit'), withScenario(withAuthCheck(autoPayInit))),
  rest.post(getApiEndpoint('autoPayController/getPayPageInit'), withScenario(withAuthCheck(getPayPageInit))),
  rest.post(getApiEndpoint('autoPayController/validateCreditCard'), withScenario(withAuthCheck(validateCreditCard))),
];
